import { Reducer } from 'redux/utils/Value'

import actionTypes from './canMarkAsSentSDoHReportActionTypes'
import InitialState from './CanMarkAsSentSDoHReportInitialState'

export default Reducer({ actionTypes, stateClass: InitialState })